import { TypographyVariant } from '@ben/orion/typography';
import type { WidgetProps } from '@rjsf/utils';
import Checkbox from '../../checkbox/checkbox';
import RadioWidget from './radio-widget';

const BooleanWidget = (props: WidgetProps) => {
  const {
    id,
    label,
    value,
    onChange,
    rawErrors,
    hideError,
    disabled,
    schema,
    readonly,
  } = props;

  const hasError = rawErrors && rawErrors.length > 0 && !hideError;

  if (schema.oneOf) {
    return <RadioWidget hasError={hasError} {...props} />;
  }

  return (
    <Checkbox
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      hasError={hasError}
      disabled={disabled || readonly}
      typographyVariant={TypographyVariant.bodyMd1}
    />
  );
};

export default BooleanWidget;
